import React from 'react'
import { Grid, Icon, Card, Button } from 'semantic-ui-react';
//import { Form } from 'formsy-semantic-ui-react';
import { dispatch } from '@rematch/core';
import _ from 'lodash';
import { toastr } from 'react-redux-toastr';
import EditContributorRole from '../../drive/modals/EditContributorRole'
import ResendDeletePlaybookInvitaion from '../../drive/modals/ResendDeletePlaybookInvitaion';
import EllipsisTooltip from './../../../../common/EllipsisTooltip'
//let authorData;
import { source } from 'react-aim';
import ImageAvater from '../../../../drive/Components/ImageAvater';
import Labels from './../../../../common/Labels';
import { Form } from 'formsy-semantic-ui-react';

@source({
    mouseEnter: (props, component) => {
        dispatch.app.setHelpContext('Participants Card');
    }
})

class PracticeViewPaneContributors extends React.Component {


    constructor(props) {
        super(props);
        this.state = {
            editUserDetails: {},
            editPlaybookInviteDetail: {},
            team: this.props.selectedPracticeLibrary ? this.props.selectedPracticeLibrary.teamId:"Select",
            onHandleChangeClicked:false
        }
        this.deleteParticipate = this.deleteParticipate.bind(this);
        this.editContibutorRole = this.editContibutorRole.bind(this);
        this.handleChangeTeam = this.handleChangeTeam.bind(this);
        this.cancelClick = this.cancelClick.bind(this);
        this.saveClick = this.saveClick.bind(this);
    }

    editContibutorRole(e, user) {
        if (this.props.status === 0) {
            dispatch.lifeCycle.modalRoleChangeOpen(true);
            this.setState({ editUserDetails: user })
        }
        else return;

    }

    resendAndDeleteInvite(e, invite) {
        dispatch.lifeCycle.resendAndDeleteInviteModal(true);
        this.setState({ editPlaybookInviteDetail: invite })
    }

    deleteParticipate(event, user) {
        let authorData = this.props.selectedPracticeLibrary.participants.filter((author) => { return author.role === 'author' });
        for (let i = 0; i < authorData.length; i++) {
            if (user.accountUserId === authorData[i].accountUserId && authorData.length === 1) {
                toastr.error('Message', 'Playbook requires at least one designer.')
                break;
            }
            else {

                let message = <div className="confirmMessage">
                    <h3>Delete participant</h3>
                    <label>{user.name}</label>
                    <p>Are you sure that you wish to delete this participant?</p>
                    <span >This action is not reversible</span>
                </div>
                toastr.confirm(message, {
                    onOk: () => {
                        let temp = this.props.selectedPracticeLibrary.participants.filter((participant) => { return participant.accountUserId === user.accountUserId });
                        // dispatch.lifeCycle.setDeleteParticipantsAsync(_.indexOf(this.props.participantsData, temp[0]));
                        let newParticipantArray = [];
                        newParticipantArray.push(temp[0]);
                        this.props.selectedPracticeLibrary.newParticipantArray = newParticipantArray;
                        let index = this.props.selectedPracticeLibrary.participants.indexOf(temp[0]);
                        if (index > -1) {
                            (this.props.selectedPracticeLibrary.participants).splice(index, 1)
                            dispatch.lifeCycle.updatePacksList({ _id: this.props.selectedPracticeLibrary._id, data: { participants: this.props.selectedPracticeLibrary.participants } })
                            dispatch.lifeCycle.editPackAsync({ selectedPack: this.props.selectedPracticeLibrary, user: this.props.user })
                        }
                    }
                });
            }
        }

    }

    handleChangeTeam(data) {
        if (data.target.value !== 'Select') {
            let teamId = data.target.value;
            for (let i = 0; i < this.props.teamList.length; i++) {
                let teamData = this.props.teamList[i];
                if (teamId.toString() === teamData._id.toString()) {
                    // team = teamData;
                    this.setState({team:teamData,onHandleChangeClicked:true})
                    break;
                }
            }
        } else {
            this.setState({team:"Select",onHandleChangeClicked:true})
        }
    }

    cancelClick(){
        this.setState({team: this.props.selectedPracticeLibrary && this.props.selectedPracticeLibrary.teamId?this.props.selectedPracticeLibrary.teamId:"Select",
        onHandleChangeClicked:false })
    }

    isActiveTeamMember(Participates)
    {
        let teamId = this.props.selectedPracticeLibrary.teamId && this.props.selectedPracticeLibrary.teamId._id
        let teamData = teamId && this.props.teamList && this.props.teamList.find((team)=>(teamId == team._id))
        let member = teamData && teamData.members.filter((member)=>(member.accountUserId == Participates.accountUserId && Participates.role != "author"))
        return teamId && member && member.length == 0 ?  true : false
    }

    saveClick(){
        if(this.state.team!=="Select"){
        //    let payload={}
        //    payload._id=this.props.selectedPracticeLibrary._id
        //    payload.data={"teamId":this.state.team._id}
        //    dispatch.lifeCycle.updatePlaybook(payload)
           this.props.selectedPracticeLibrary.teamId = this.state.team._id
           dispatch.lifeCycle.editPackAsync({ selectedPack: this.props.selectedPracticeLibrary, user: this.props.user })
           this.setState({onHandleChangeClicked:false })
        } else {
            // let payload={}
            // payload._id=this.props.selectedPracticeLibrary._id
            // payload.data={"teamId":null}
            // dispatch.lifeCycle.updatePlaybook(payload)
            this.props.selectedPracticeLibrary.teamId = null
            dispatch.lifeCycle.editPackAsync({ selectedPack: this.props.selectedPracticeLibrary, user: this.props.user })
            this.setState({onHandleChangeClicked:false })
        }
    }

    render() {
        let isAuthorizedToDelete = false;
        this.props.selectedAccount && this.props.selectedAccount.users && this.props.selectedAccount.users.map(user => {
            let customerAdminsId = user.id && user.id._id ? user.id._id : user.id;
            if ((customerAdminsId && customerAdminsId.toString() === this.props.user && this.props.user._id.toString()) && user.role === "customerAdmin") {
                isAuthorizedToDelete = true;
            }
        });

        if (!isAuthorizedToDelete) {
            if (this.props.selectedPracticeLibrary && this.props.selectedPracticeLibrary.createdBy && this.props.user._id.toString() === this.props.selectedPracticeLibrary.createdBy.toString()) {
                isAuthorizedToDelete = true;
            }
        }

        return (
            <Grid >
                <Grid.Column>
                    {this.props.isInDesign && 
                    this.props.teamList && this.props.teamList.length>0 && 
                    this.props.status === 0 && isAuthorizedToDelete && 
                    <Grid.Row 
                    style={{backgroundColor: "#F3F8FB",
                        padding: "10px 10px 10px 0",
                        marginBottom: "10px",
                        borderRadius: "5px",
                    }}>
                        <Grid.Column width={16} style={{marginBottom:"5px"}}>
                            <label className=' f_11' >Select Team</label>
                           
                        </Grid.Column>
                        <Grid.Column width={5} style={{ display:"flex", flexDirection:"row"}} >
                            {this.props.teamList && this.props.teamList.length>0 && <Form.Field 
                            id='TeamList' control='select'
                            onChange={this.handleChangeTeam}
                            value={this.state.team && this.state.team._id?this.state.team._id:"Select"}
                            className="formcyFormErrorMsg">
                                <option value={"Select"}>Select</option>
                                {this.props.teamList && this.props.teamList.map((team, index) => {
                                    return (
                                        <option key={index} value={team._id}>{team.name}</option>
                                    );
                                }, this)}
                            </Form.Field>
                            }
                            {this.state.onHandleChangeClicked && <div
                                style={{marginLeft:"8px"}}
                                className="actionBtn"
                                id={"action_id"} >
                                <Button
                                    type="button"
                                    icon="cancel"
                                    className="button-cancel pad_5"
                                    onClick={this.cancelClick}
                                    id={'cancel'} />
                                <Button
                                    type="submit"
                                    icon="check"
                                    className="button-submit pad_5"
                                    onClick={this.saveClick}
                                    id={'check'} />
                            </div>}
                        </Grid.Column>
                    </Grid.Row>}
                    {this.props.isInDesign && this.props.selectedPracticeLibrary && 
                    this.props.selectedPracticeLibrary.teamId && 
                    this.props.selectedPracticeLibrary.teamId.name && 
                    (this.props.status !== 0 || !isAuthorizedToDelete) && 
                    <Grid.Row>
                        <Labels
                            name="Selected Team"
                            text= {this.props.selectedPracticeLibrary.teamId.name}
                            style={{marginBottom:"20px"}}
                        />
                    </Grid.Row>}
                    {this.props.isPublished && this.props.selectedPracticeLibrary && 
                    this.props.selectedPracticeLibrary.teamId && 
                    this.props.selectedPracticeLibrary.teamId.name && <Grid.Row>
                        <Labels
                            name="Selected Team"
                            text= {this.props.selectedPracticeLibrary.teamId.name}
                            style={{marginBottom:"20px"}}
                        />
                    </Grid.Row>}
                    <Card.Group>
                        {this.props.selectedPracticeLibrary.participants && this.props.selectedPracticeLibrary.participants.length ?
                            this.props.selectedPracticeLibrary.participants.map(function (Participates, index) {
                                return (
                                    <Card className="contributorCard" key={index}  style={{ "cursor": this.props.selectedPracticeLibrary.status==0?'pointer':"default" }}>  {/* KLM-9401 */}
                                        <Card.Content onClick={(e) => this.editContibutorRole(e, Participates)}>
                                            <ImageAvater user={Participates} profilePic={Participates.imageUrl} />
                                            <Card.Header>

                                                <EllipsisTooltip
                                                    name={Participates.name}
                                                    style={{ "cursor": this.props.selectedPracticeLibrary.status==0?'pointer':"default" }}
                                                    line={2} />
                                            </Card.Header>
                                            <Card.Meta className="f_10">{Participates.role === "author" ? "Designer" : Participates.role}</Card.Meta>
                                            {this.props.selectedPracticeLibrary.status == 4 && (Participates.role == "contributor" || Participates.role == "reviewer") && this.isActiveTeamMember(Participates)?<div className='f_9 clr-orange'>( Deprecated )</div>:""}
                                            
                                        </Card.Content>
                                        {this.props.status === 0 && isAuthorizedToDelete && Participates.role !== "author"
                                            ? <Icon className="trashImage trash-color" floated='right'
                                                onClick={(event) => this.deleteParticipate(event, Participates)}
                                                name="trash alternate" style={{ "cursor": "pointer" }} />
                                            : ''
                                        }
                                    </Card>
                                );
                            }, this)
                            : ''}

                        {this.props.playbookInvitaions && this.props.playbookInvitaions.length ?
                            this.props.playbookInvitaions.map(function (invite, index) {
                                return (
                                    <Card className="contributorCard playbookInviteBg" style={{ "cursor": 'pointer' }} key={index} >
                                        <Card.Content onClick={(e) => this.resendAndDeleteInvite(e, invite)}>
                                            <ImageAvater
                                                user={invite}
                                                className="f_14 w_32 h_32 " />
                                            <Card.Header>
                                                <EllipsisTooltip
                                                    name={invite.firstName + ' ' + invite.lastName}
                                                    line={2} />
                                            </Card.Header>
                                            <Card.Meta className="f_10">{invite.role + " (Invited)"}</Card.Meta>
                                        </Card.Content>
                                    </Card>
                                );
                            }, this)
                            : ''}

                    </Card.Group>

                    {this.props.isRoleChangeModalOpen ?
                        <EditContributorRole isRoleChangeModalOpen={this.props.isRoleChangeModalOpen}
                            participantsData={this.props.selectedPracticeLibrary.participants}
                            editUserDetails={this.state.editUserDetails}
                            selectedPracticeLibrary={this.props.selectedPracticeLibrary}
                            user={this.props.user}
                        /> : ''}

                    {this.props.isPlaybookInvitationModalOpen ?
                        <ResendDeletePlaybookInvitaion isPlaybookInvitationModalOpen={this.props.isPlaybookInvitationModalOpen}
                            editPlaybookInviteDetail={this.state.editPlaybookInviteDetail}
                            selectedOrganisation={this.props.selectedOrganisation}
                            organizationId={this.props.organizationId}
                            user={this.props.user}
                            teamName={this.props.selectedPracticeLibrary.name}
                        /> : ''}

                </Grid.Column>
            </Grid>

        )
    }
}

export default PracticeViewPaneContributors